const initFeaturedBlogLiveSearch = (section) => {
  const input = section.querySelector('.featured-blog-live-search__input');
  const searchButton = section.querySelector('.search-button');
  const results = section.querySelector('.featured-blog-live-search__results');

  if (!input || !results || !searchButton) return;

  let controller;

  // input.addEventListener('input', async () => {
  //   const blogPosts = document.querySelector('.featured-blog-posts');
  //   const originalBlogs = blogPosts?.querySelector('.resource-list[data-testid="featured-blog-posts"]');

  //   const q = input.value.trim();

  //   if (!q) {
  //     results.style.display = 'none';
  //     results.innerHTML = '';

  //     if (originalBlogs) {
  //       originalBlogs.style.display = '';
  //     }

  //     return;
  //   }

  //   // searching
  //   results.style.display = 'block';

  //   if (originalBlogs) {
  //     originalBlogs.style.display = 'none';
  //   }

  //   if (controller) controller.abort();
  //   controller = new AbortController();

  //   const url = new URL('/search/suggest', location.origin);
  //   url.searchParams.set('q', q);
  //   url.searchParams.set('section_id', 'predictive-search-blogs');
  //   url.searchParams.set('resources[type]', 'article');
  //   url.searchParams.set('resources[limit]', '6');

  //   try {
  //     const res = await fetch(url, { signal: controller.signal });
  //     const html = await res.text();

  //     const parsed = new DOMParser()
  //       .parseFromString(html, 'text/html')
  //       .querySelector('[data-search-results]');

  //     if (parsed) {
  //       results.innerHTML = parsed.innerHTML;
  //     }
  //   } catch (e) {
  //     if (e.name !== 'AbortError') console.error(e);
  //   }
  // });

  input.addEventListener('keyup', (e) => {
    if (e.key === 'Enter' && window.location.pathname === '/' && input.value.trim()) {
      localStorage.setItem('search_blog', input.value.trim());
      window.location.href = '/blogs/blog';
    }
  });

  searchButton.addEventListener('click', () => {
    if (window.location.pathname === '/' && input.value.trim()) {
      localStorage.setItem('search_blog', input.value.trim());
      window.location.href = '/blogs/blog';
    }
  });
};

document.querySelectorAll('.featured-blog-posts')
  .forEach(initFeaturedBlogLiveSearch);
